<div class="no-access-banner">
    <img src="assets/images/svg/tbk_modal_banner.svg" alt="Transbank banner" />
</div>

<div class="no-access-body">
    <h2 class="no-access-title mb-3">Agrega tu tarjeta en Webpay</h2>

    <p class="no-access-message">
        Te redirigiremos a Webpay para completar el registro de tu tarjeta.
    </p>

    <button
        mat-flat-button
        class="no-access-btn"
        (click)="close()"
    >
        Continuar
    </button>
</div>
